import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './features/home/home.component';
import { ContactComponent } from './features/contact/contact.component';
import { RentalPropertiesComponent } from './features/rental-properties/rental-properties.component';
import { SalesPropertiesComponent } from './features/sales-properties/sales-properties.component';
import { NewProjectsComponent } from './features/new-projects/new-projects.component';
import { AreasComponent } from './features/areas/areas.component';
import { AboutComponent } from './features/about/about.component';
import { ViewDetailsComponent } from './features/view-details/view-details.component';


const routes: Routes = [
  { path: "", redirectTo: "/home", pathMatch: "full" },
  { path: "home", component: HomeComponent },
  { path: "rental-properties", component: RentalPropertiesComponent },
  { path: "sales-properties", component: SalesPropertiesComponent },
  { path: "new-projects", component: NewProjectsComponent },
  { path: "areas", component: AreasComponent },
  { path: "about-us", component: AboutComponent },
  { path: "contact", component: ContactComponent },
  { path: "viewDetails/:type/:id", component: ViewDetailsComponent },

];

@NgModule({
  imports: [RouterModule.forRoot(
    routes, 
      {scrollPositionRestoration: 'top'}  //it will always force the page to start from top rather than a random location.
  )],
  exports: [RouterModule]
})
export class AppRoutingModule { }
